<div class="page">
    <div id="preloader">
        <div id="status"></div>
    </div>
        <!-- Organization structured data (JSON-LD) -->
        <script type="application/ld+json">
        {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Qualibar",
            "url": "https://qualibar.com",
            "logo": "https://qualibar.com/images/favicon.png",
            "description": "Since 2019, we have helped our clients release better software products and have improved the quality of legacy products.",
            "contactPoint": [{
                "@type": "ContactPoint",
                "contactType": "customer service",
                "url": "https://qualibar.com/contact-us"
            }]
        }
        </script>
    <app-header></app-header>
    <router-outlet />
    <app-footer></app-footer>
    <app-scroll-to-top></app-scroll-to-top>
</div>